import { render, staticRenderFns } from "./departmentItem.vue?vue&type=template&id=39a1d6ac"
import script from "./departmentItem.vue?vue&type=script&lang=js"
export * from "./departmentItem.vue?vue&type=script&lang=js"
import style0 from "./departmentItem.vue?vue&type=style&index=0&id=39a1d6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports